import { render, staticRenderFns } from "./ModalCriteriosInscripciones.vue?vue&type=template&id=3e31ec6f"
import script from "./ModalCriteriosInscripciones.vue?vue&type=script&lang=js"
export * from "./ModalCriteriosInscripciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports